import Parallax from 'parallax-js';

import appStoreButton from './../../resources/images/app-store-btn.png';
import playMarketButton from './../../resources/images/play-market-btn.png';
import webScreens from './../../resources/images/hero-web-screens.png';
import mobileScreens from './../../resources/images/hero-mobile-screens.png';
import card1 from './../../resources/images/card1.png';
import card2 from './../../resources/images/card2.png';
import chips from './../../resources/images/chips.png';
import dice from './../../resources/images/dice.png';
import './index.scss';


function HeroSection() {



    return (
        <div className="hero-section">
            <div className="container">
                <h1 className="page-title">spring news</h1>
                <h2 className="hero-title">The iGaming Industry in Your Pocket</h2>
                <h3 className="hero-action-message">Download SpringNews for free now!</h3>
                <p className="hero-description">SpringNews is your #1 destination for high-quality gambling
                    news,<br/> information, analysis, and data, accessible on the go! Wherever you are, be the first to
                    learn about top iGaming updates as it happens.</p>
                <div className="hero-app-download-wrapper">
                    <a href="https://apps.apple.com/app/springbme/id1489137198?ls=1">
                        <img src={appStoreButton} alt=""/>download in app store
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.betconstruct.springbme&fbclid=IwAR1R3vPz3eoqqH6RCdswkCOAMfMI79Sjj3Y3N5ZerWhrgG3-y5aENJYprN0">
                        <img src={playMarketButton} alt=""/>download in play market
                    </a>
                </div>
                <div className="hero-screen-illustration-block">
                    <picture className="hero-screen-illustration">
                        <source media="(min-width:501px)" srcSet={webScreens} />
                        <img src={mobileScreens} alt="" />
                    </picture>
                </div>
            </div>
            <div className="hero-decoration-wrapper">
                <img src={card2} alt="" className="card2" />
                <img src={card1} alt="" className="card1" />
                <img src={chips} alt="" className="chips" />
                <img src={dice} alt="" className="dice" />
            </div>
        </div>
    )
}

export default HeroSection;